import { DataFilterDateRange } from '@fcom/common/interfaces';

export const dataFilterDateRangeValue = (filter: string): DataFilterDateRange => {
  switch (filter) {
    case 'lastYear':
      return DataFilterDateRange.LAST_YEAR;
    case 'lastSixMonths':
      return DataFilterDateRange.LAST_SIX_MONTHS;
    case 'yearToDate':
    default:
      return DataFilterDateRange.YEAR_TO_DATE;
  }
};
